import useFetchContract from "./use-fetch-contract";

export default function usePrefill() {
  const {
    isLoading: useFetchContractIsLoading,
    error: useFetchContractError,
    get,
  } = useFetchContract();

  const getPrefill = async (id: string) => {
    const res = (await get(`prefill/xero/contact/${id}`)) as any;

    return res.data;
  };

  return {
    isLoading: useFetchContractIsLoading,
    error: useFetchContractError,
    getPrefill,
  };
}
